import styled from 'styled-components';
import { Link } from 'gatsby';
export const Article = styled.article`
  padding: 0 1rem;
  margin-bottom: 3rem;
  transition: var(--mainTransition);
  @media screen and (min-width: 992px) {
    display: flex;
    align-items: flex-start;
    margin-bottom: 2rem;
  }
`;
export const ImageContainer = styled(Link)`
  display: block;
  text-align: center;
  margin: auto;
  margin-bottom: 1rem;
  width: 160px;
  height: 160px;
  & img {
    transition: var(--mainTransition);
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    margin: auto;
  }
  @media screen and (min-width: 992px) {
    margin: 0 auto;
    margin-right: 1.25rem;
    & img {
      margin: left;
    }
  }
`;

export const Typography = styled.div`
  font-size: 1rem;
  text-align: center;
  padding: 0;
  margin: 0;
  line-height: 1.5;
  flex: 1;

  @media screen and (min-width: 992px) {
    text-align: left;
  }
`;

export const Title = styled.h3`
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  padding: 0;
  margin-bottom: 0.3rem;
`;

export const TimeStamp = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: inherit;
  font-size: 0.9rem;
  opacity: 0.6;
  margin-bottom: 0.5rem;
  & svg {
    font-size: 1rem;
    margin-right: 0.25rem;
  }
  @media screen and (min-width: 992px) {
    justify-content: flex-start;
    margin-bottom: 0.75rem;
  }
`;
